import { Component, Input } from '@angular/core'
import { Router } from '@angular/router'
import { Facet } from '@spartacus/core'
import {
  ProductGridItemComponent,
  ProductListItemContext,
  ProductListItemContextSource
} from '@spartacus/storefront'

@Component({
    selector: 'eb-product-grid-item',
    templateUrl: './eb-product-grid-item.component.html',
    styleUrls: ['./eb-product-grid-item.component.scss'],
    providers: [
        ProductListItemContextSource,
        { provide: ProductListItemContext, useExisting: ProductListItemContextSource }
    ],
    standalone: false
})
export class EbProductGridItemComponent extends ProductGridItemComponent {
  @Input() facets: Facet[]

  constructor(
    productListItemContextSource: ProductListItemContextSource,
    protected router: Router
  ) {
    super(productListItemContextSource)
  }

  get queryParams(): { [key: string]: string } {
    const [, paramString] = this.router.url.split(/\?/)
    if (paramString) {
      const params = new URLSearchParams(paramString)
      const query = params.get('query')
      return { query }
    }
    return {}
  }
}
